import { Injectable } from '@angular/core';
import { NotificationMessageType } from './enums';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {
    duration = 8000;
    timeoutHandle = 0;

    showNotification(type: NotificationMessageType, text: string): void {
        const containerEl = this.getNotificationContainerElement();
        this.removeTypeClasses(containerEl);
        containerEl.classList.add(type);
        containerEl.innerText += text + '\r\n';
        this.changeNotificationVisibility(containerEl, true);
        window.clearTimeout(this.timeoutHandle);
        this.timeoutHandle = window.setTimeout(() => {
            containerEl.innerText = '';
            this.hideNotification();
        }, this.duration);
    }

    hideNotification(): void {
        this.changeNotificationVisibility(this.getNotificationContainerElement(), false);
    }

    private changeNotificationVisibility(el: HTMLDivElement, visible: boolean): void {
        if (visible) {
            el.style.display = '';
        } else {
            el.style.display = 'none';
        }
    }

    private getNotificationContainerElement(): HTMLDivElement {
        return document.getElementById('notifications-container') as HTMLDivElement;
    }

    private removeTypeClasses(el: HTMLDivElement): void {
        el.classList.remove(NotificationMessageType.error);
        el.classList.remove(NotificationMessageType.info);
        el.classList.remove(NotificationMessageType.success);
        el.classList.remove(NotificationMessageType.warning);
    }
}
